// extracted by css-extract-rspack-plugin
export default {"hideOnPrint":"NrWrQVvOR7kwpn5m__hideOnPrint___"};